import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller } from "react-hook-form";

const FormDatePicker = ({
  label,
  name,
  control,
  errors,
  required = false,
  disabled = false,
}) => {
  return (
    <Box>
      {/* Label */}
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: "var(--app-text-muted)",
          mb: "6px",
          fontFamily: "figtree"
        }}
      >
        {label}
        {required && <span style={{ color: "#d32f2f" }}> *</span>}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DatePicker
              value={field.value}
              onChange={(date) => field.onChange(date)}
              disabled={disabled}
              format="dd-MM-yyyy"
              maxDate={new Date()}
              enableAccessibleFieldDOMStructure={false}
              slots={{
                toolbar: () => null,
              }}
              slotProps={{
                textField: {
                  disabled: disabled,
                  fullWidth: true,
                  variant: "filled",
                  hiddenLabel: true,
                  placeholder: "dd-MM-yyyy",
                  error: !!errors?.[name],
                  helperText: errors?.[name]?.message || errors?.dob,
                  InputProps: {
                    disableUnderline: true,
                    sx: {
                      height: "48px",
                      borderRadius: "8px",
                      backgroundColor: disabled
                        ? "var(--app-surface-2)"
                        : "var(--app-surface)",
                      border: "1px solid var(--app-border)",
                      px: "12px",
                      fontFamily: "Figtree",
                    },
                  },
                  sx: {
                    "& .MuiFilledInput-root": {
                      backgroundColor: disabled
                        ? "var(--app-surface-2) !important"
                        : "var(--app-surface) !important",
                      borderRadius: "8px",
                      border: "1px solid var(--app-border)",
                      transition: "none !important",
                    },

                    "& .MuiFilledInput-root:hover": {
                      backgroundColor: disabled
                        ? "var(--app-surface-2) !important"
                        : "var(--app-surface) !important",
                    },

                    "& .MuiFilledInput-root.Mui-focused": {
                      backgroundColor: disabled
                        ? "var(--app-surface-2) !important"
                        : "var(--app-surface) !important",
                      border: "1px solid var(--app-border)",
                      boxShadow: "none",
                    },

                    "& .MuiInputBase-root:hover": {
                      backgroundColor: disabled
                        ? "var(--app-surface-2) !important"
                        : "var(--app-surface) !important",
                    },

                    "& .MuiFilledInput-input": {
                      padding: "14px 0",
                      fontFamily: "Figtree",
                      fontSize: "14px",
                      color: disabled ? "var(--app-text-muted)" : "var(--app-text)",
                      cursor: disabled ? "not-allowed" : "pointer",
                    },

                    "& .MuiSvgIcon-root": {
                      color: disabled ? "var(--app-text-muted)" : "var(--app-text-muted)",
                    },

                    "& .MuiFilledInput-root:before": {
                      display: "none !important",
                    },
                    "& .MuiFilledInput-root:after": {
                      display: "none !important",
                    },
                  },
                },
              }}

            />
          )}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default FormDatePicker;
